import { render, staticRenderFns } from "./List-role.vue?vue&type=template&id=fcebbd76&scoped=true"
import script from "./List-role.vue?vue&type=script&lang=js"
export * from "./List-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcebbd76",
  null
  
)

export default component.exports